// import React from "react";
// import { TenantVideoContent } from "../Components/TenantVideoContent";

// const TenantVideo = () => {
//   return <TenantVideoContent />;
// };

// export default TenantVideo;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { TenantVideoContent } from "../Components/TenantVideoContent";

const TenantVideo = () => {
  const seoData = getSEOData("/tenant-video");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <TenantVideoContent />
    </>
  );
};

export default TenantVideo;